import axios from 'axios'

const ORGS = '/api/orgs'

const authCfg = (token) => ({ headers: { Authorization: `Bearer ${token}` } })

const listApiKeys = async (slug, token) => {
  const res = await axios.get(`${ORGS}/${slug}/api-keys`, authCfg(token))
  return res.data
}

const createApiKey = async ({ slug, name }, token) => {
  const res = await axios.post(`${ORGS}/${slug}/api-keys`, { name }, authCfg(token))
  return res.data
}

const revokeApiKey = async ({ slug, id }, token) => {
  const res = await axios.delete(`${ORGS}/${slug}/api-keys/${id}`, authCfg(token))
  return res.data
}

const apiKeyService = { listApiKeys, createApiKey, revokeApiKey }

export default apiKeyService
